module.exports = __webpack_public_path__ + "img/source_book-item7.9b70c834.png";